export class Collections {
  static Users = 'users';
  static Roles = 'roles';
	static UserInvites = 'user-invites';

	static AutomaticEmails = 'automatic-emails';
	static SentEmails = 'sent-emails';

	static BlogAuthors = 'blog-authors';
	static BlogArticles = 'blog-articles';
	static BlogCategories = 'blog-categories';

	/**
	 * Subcollections
	 */
	static History = 'history';
	static Notes = 'notes';
	static ProjectPermissions = 'project-permissions';

	static HistorySub(collection: string, docId?: string) {
		return `${collection}/${docId || '{docId}'}/${Collections.History}`;
	}

	static ProjectPermissionsSub(collection: string, docId?: string) {
		return `${collection}/${docId || '{docId}'}/${Collections.ProjectPermissions}`;
	}

	static get UserHistory() {
		return Collections.HistorySub('users');
	}

	static get UserProjectPermissions() {
		return Collections.ProjectPermissionsSub('users');
	}

	static UserHistorySub(docId: string) {
		return Collections.HistorySub('users', docId);
	}

	static get RoleHistory() {
		return Collections.HistorySub('roles');
	}

	static RoleHistorySub(docId: string) {
		return Collections.HistorySub('roles', docId);
	}
}
